// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getData = createAsyncThunk('presentation/getData', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationList`, {params})
  return {
    params,
    data: response.data.Response.items,
    totalPages: response.data.Response.total_items
  }
})

export const getDataAll = createAsyncThunk('presentation/getDataAll', async params => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationListAll`, {params})
  return { dataAll: response.data.Response.items }
})

export const getPresentation = createAsyncThunk('presentation/getPresentation', async id => {
  let response = {}
  if (id > 0) {
    response = await axios.get(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationEdit/${id}`)
    return response.data.Response.item
  } else {
    return response
  }
})

export const addPresentation = createAsyncThunk('presentation/addPresentation', async (CreatePresentation, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationCreate`, {
    Request: {
      CreatePresentation
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().presentations.params))
  await dispatch(getAllData())
  return CreatePresentation
})

export const updatePresentation = createAsyncThunk('presentation/addPresentation', async (UpdatePresentation, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationUpdate`, {
    Request: {
      UpdatePresentation
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().presentations.params))
  await dispatch(getDataParent())
  return UpdatePresentation
})

export const changeStatus = createAsyncThunk('presentation/changeStatus', async (ChangeStatusPresentation, { dispatch, getState }) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationChangeStatus`, {
    Request: {
      ChangeStatusPresentation
    }
  })

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().presentations.params))
  return ChangeStatusPresentation
})

export const deletePresentation = createAsyncThunk('presentation/deletePresentation', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_BASE_API}Schedule/presentation/presentationDelete/${id}`)

  if (response.data.Response.Code === 1) {
    toast.success('Event success')
  } else {
    toast.error('Error')
  }

  await dispatch(getData(getState().presentations.params))
  await dispatch(getAllData())
  return id
})

export const appPresentationsSlice = createSlice({
  name: 'presentations',
  initialState: {
    data: [],
    dataAll: [],
    total: 1,
    params: {},
    allData: [],
    selectedPresentation: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getDataAll.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getDataAll.fulfilled, (state, action) => {
        state.loading = false
        state.dataAll = action.payload.dataAll
      })
      .addCase(getPresentation.fulfilled, (state, action) => {
        state.selectedPresentation = action.payload
      })
  }
})

export default appPresentationsSlice.reducer
